module.exports = __webpack_public_path__ + "img/depense_totale_dark_mode.68e58643.svg";